<template>
	<div class="not-found">

		<h1>404<br/>
		{{tr.not_found}}</h1>
	</div>
</template>

<script>
export default {

  name: '404',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.not-found{
	padding:180px 0;
	text-align: center;
}

h1{
	font-size:42px;
}
</style>